import { createFileRoute, redirect } from "@tanstack/react-router";
import { ProductAreaSetupPage } from "@/features/product-areas/pages/product-area-setup-page";

// The preview is deliberately not prefetched here: it is a freshness-stamped
// decision, and serving one from a loader cache would let a stale allow survive
// a revisit. The page fetches it on mount instead.
export const Route = createFileRoute("/_authed/tenants/$slug/settings/product-areas/$area/setup")({
  beforeLoad: ({ context, params }) => {
    if (!context.authority.permissions.includes("product_areas.activate")) {
      throw redirect({
        to: "/tenants/$slug/settings/product-areas",
        params: { slug: params.slug },
        replace: true,
      });
    }
  },
  component: ProductAreaSetupPage,
});
